import PageLoadedQueue from "../PageLoadedQueue";

/**
 * Check for elements with data-standalone-portal attribute and load the URL contents into the element.
 */
class StandalonePortal {

    protected containerElement: HTMLElement;
    protected standaloneElement: HTMLElement;
    protected standalonePortalUrl: string;
    protected screenMinWidth: number;

    constructor(containerElement: HTMLElement) {
        this.containerElement = containerElement;
        this.standaloneElement = null;
        this.standalonePortalUrl = containerElement.dataset.standalonePortal;
        this.screenMinWidth = parseInt(containerElement.dataset.screenMinWidth);
        this.handleViewportChange = this.handleViewportChange.bind(this);

        this.initialize();
    }

    protected async initialize() {
        if (this.screenMinWidth) {
            const mediaQuery = window.matchMedia(`(min-width: ${this.screenMinWidth}px)`);
            mediaQuery.addEventListener('change', this.handleViewportChange);
            this.handleViewportChange(mediaQuery);
        } else {
            await this.loadStandalone();
            this.displayStandalone();
        }
    }

    protected async handleViewportChange(e) {
        if (e.matches) {
            await this.loadStandalone();
            this.displayStandalone();
        } else {
            this.hideStandalone();
        }
    }

    protected displayStandalone() {
        if (this.containerElement.isConnected) {
            this.containerElement.replaceWith(this.standaloneElement);
            const event = new CustomEvent('Plandent.StandalonePortal.Loaded');
            document.dispatchEvent(event);
        }
    }

    protected hideStandalone() {
        if (this.standaloneElement.isConnected) {
            this.standaloneElement.replaceWith(this.containerElement);
            const event = new CustomEvent('Plandent.StandalonePortal.Unloaded');
            document.dispatchEvent(event);
        }
    }

    protected async loadStandalone() {
        if (this.standaloneElement) {
            return;
        }
        const response = await fetch(this.standalonePortalUrl);
        if (response.ok) {
            const text = await response.text();
            if (text === '') {
                this.containerElement.remove();
            } else {

                this.standaloneElement = document.createElement("div");
                this.standaloneElement.innerHTML = text;
                this.standaloneElement = this.standaloneElement.firstElementChild as HTMLElement;
            }
        }
    }

    static initialize() {
        const containerElements: NodeListOf<HTMLElement> = document.querySelectorAll('[data-standalone-portal]');
        containerElements.forEach((containerElement) => {
            if (containerElement) {
                new StandalonePortal(containerElement);
            }
        });
    }
}

PageLoadedQueue.addFunction(StandalonePortal.initialize);
